import Marquee from "react-fast-marquee";
import { useContent } from "@/context/ContentContext";

export const EditorialMarquee = () => {
  const { content } = useContent();
  return (
    <div
      className="relative z-10 -rotate-1 bg-[#2C4C3B] py-5 shadow-[0_20px_40px_rgba(28,25,23,0.15)]"
      data-testid="editorial-marquee"
    >
      <Marquee speed={35} gradient={false} pauseOnHover>
        {content.marquee.items.map((item) => (
          <span key={item} className="mx-8 flex items-center gap-8">
            <span className="font-display text-lg italic tracking-wide text-[#FAF8F5]/95 md:text-xl">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-[#C5A059]" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
